export default {
  token: '로그인',
  navbar: {
    login: '로그인',
    logOut: '로그아웃',
    register: '무료 회원가입',
    cart: '장바구니',
    member: '마이페이지',
    appDownload: 'APP 다운',
    seller: '판매자 APP',
    buyer: '바이어 APP',
    sellerTitle: '판매자 App',
    buyerTitle: '바이어 App',
    ios: 'iOS 다운',
    android: 'Android 다운',
    Member: '회원 신청'
  },
  lang: {
    zh: '简体中文',
    en: 'English',
    ko: '한국어'
  },
  menus: {
    describe: '올 체인 로드 풀세트 디지털매매 종합서비스 플랫폼',
    home: '홈',
    purchase: '옴니 시나리오 쇼핑',
    welcomeToYiwu: '이우에 오시걸 환영합니다',
    logistics: '글로벌물류',
    financial: '금융서비스',
    customerService: '고객서비스'
  },
  navigation: {
    personalAlive: '프라이빗 생방송',
    personalGoods: '프라이빗 상품',
    demandGoods: '상품 신청',
    productType: '상품',
    serveType: '서비스',
    customerCenter: '고객센터',
    sellerEntry: '판매자 페이지',
    marketService: '시장 서비스'
  },
  category: {
    all: '카테고리',
    hotRanking: '인기상품 랭킹',
    shopRanKing: '점포 랭킹',
    explosion: '시즌 인기상품',
    live: '판매자 방송',
    notice: '공지사항',
    marketIntroduction: '시장소개',
    deatilDesc: '자세한 내용'
  },

  newJoin: {
    dataDoenload: '자료 다운로드',
    ranking: '베스트셀러',
    floorLayout: '층별소개'
  },
  intoYiwu: {
    walkInto: '이우 소개',
    yiwuDescribe: '시장 위에 형성된 도시',
    welcome: '환영합니다!',
    yiwuInfomation:
      '시진핑 주석은 세계적인 외교 행사에서 여러 차례 이우시를 소개한 바 있으며, 이우를 글로벌 ‘소상품 도시’로 포지셔닝하였습니다. 저희는 세계 각지에서 이우시를 방문하는 분들을 위하여 출입국 관리, 비즈니스 지원에서부터 현지 생활에 이르기까지 모든 서비스를 제공하여, 모두가 이우시에서 쉽게 무역에 참여 할 수 있는 ‘전세계 모든 상품을 사고 파는’ 글로벌 시장을 제공합니다. ',
    seeMap: '지도 보기',
    scenic: '4A 관광명소 둘러보기',
    yiwuGuid: '외국인 관리',
    yiwuGuid1: '구매자 서비스',
    yiwuGuid2: '이우 전시회',
    yiwuGuid3: '하이테크 특구',
    hotel: '호텔 예약',
    content:
      '이우시 출입국 관리국과 협력하여, 이우시를 방문하는 외국인들을 위한 원스톱 행정 및 무역 사무 서비스 플랫폼 제공(준비중)',
    content1:
      '사업자 및 외국인 구매자를 위해 시장, 무역,생활 등 정책 관련 컨설팅을 제공하고 외국법인 등록, 외국인 사업허가증, 외국인 거류허가증 등 서비스 업무 관련 안내 및 대행 ',
    content2:
      '이우박람회, 철물(금속) 박람회, 수입전시회,해외전시회, 삼림용품박람회 등을 개최하여 세계 각국의 사람들이 전시회 참가를 통해 이우시를 알고 이우시로 무역 여행을 떠날 수 있는 기회 제공 ',
    content3:
      'CCC 그룹 산하의 6개 호텔에서 가장 낮은 가격으로 가장 우수한 숙박, 다이닝, 회의 서비스를 제공하며, 이우 시장 방문 시 가장 편안하고 적합한 장소 마련',
    content4:
      'CCC 그룹·물산크로스보더(수입)전자상거래특구를 포함하여 오피스텔, 호텔, 상업 시설, 창고, 주차장 등 부대시설에 이르기까지 모두 조성중인 이우종합 보세 구역에 위치'
  },
  logisticsFinancial: {
    financialTitle: '신용 금융',
    financialTitle2: '신용은 무역과 금융의 기반입니다',
    contentTille1: '신용 경고',
    contentTille2: '무역 보험',
    contentTille3: '산업 체인 금융',
    content1:
      '사회화를 기본으로, 전문화를 바탕으로 하여,인터넷이 매개체가 되며 시장이 액세스 포인트인 이우 국제 무역 종합 서비스 및 경제 사고 조기경보 플랫폼을 2009 년 9 월 18 일 정식 오픈하였습니다.',
    content2:
      '저희는 중국 수출 신용보험공사와 연계하여 신용 보험, 수출 융자, 정보 컨설팅, 미수금 관리 등 분야에서 대외무역 기업을 위해 편리하면서도 완벽한 서비스를 제공함으로써 기업이 해외시장 진출 방안을 적극 모색할 수 있도록 외환 리스크 및 수출 융자 보장 등 서비스를 제공한다.',
    enter: '들어가기',
    company: '중국 수출 신용보험공사',
    logisticsTitle: '물류 유통',
    logisticsTitle1: '이우시는 국가급 물류 허브센터',
    listTitle: '이우 물류의 장점',
    listTitle1: '이우 종합보세구역',
    listTitle2: 'e-WTP 노드',
    yxo: '중국-유럽 화물열차',
    listContent:
      '이우시는 전국 최초의 17개 국제항구 도시 중 하나이며 국가 물류 허브 운송 도시입니다(이우의 상품무역 서비스형 국가 물류 허브가 중국 최초 물류 허브 조성 리스트에 선정).',
    listContent0:
      '2019년 1월~12월 국내 우편 및 택배 배송규모가 총 48억 8,400만건에 이르렀으며, 택배 업무량은 광저우에 이어 전국 도시 중 2위를 차지하여 베이징, 상하이, 선전보다 높은 수준을 기록하고 있습니다. ',
    listContent1:
      '비준을 통과한 이우 종합보세구역은 글로벌 무역체인 활성화를 촉진하는 긍정적인 역할을 합니다.이우 종합보세구역의 가장 큰 특징은 디지털 무역을 주도로 보세 무역 전시를 특징으로 삼아, 이우 국제 무역 편의성과 자유화 수준을 한 층 높인다는 데 있습니다.',
    listContent2:
      'e-WTP는 알리바바 그룹이 주도한 글로벌 전자상거래 플랫폼으로 개발도상국, 중소기업, 젊은 창업가들이 보다 편리하게 글로벌 마켓으로 진출하고 세계 경제에 참여할 수 있도록 지원합니다. 2019년 6월, 이우와 알리바바는 e-WTP 글로벌 혁신 센터 공동 구축을 위한 MOU를 체결하였습니다.',
    listContent3:
      '2014년 9월, 시진핑 주석이 처음으로 ‘이신오우철로(중국 이우시와 스페인 마드리드를 잇는 대륙 횡단 철도)’ 계획을 제안하였으며, 이 철도는 태평양부터 대서양까지 유라시아 대륙을 관통하였습니다. 현재 이우에서 12개 지역으로 향하는 국제 열차 노선이 개통되어 있습니다.',
    logisticsInfo: 'CCCL',
    logisticsInfo1: 'Global Yida',
    logisticsInfo2: '3자 물류 서비스',
    warehouse: '高仓',
    warehouse1: '集货仓',
    warehouse2: '해외 창고',
    despatchWay: 'LCL 선적',
    despatchWay1: 'FCL 선적',
    despatchWay2: '가격 문의',
    logisticsWay: '短驳',
    logisticsWay1: '快递',
    logisticsWay2: '국내 물류',
    thirdDescribe1:
      '시장의 업스트림, 다운스트림 비즈니스에 중점을 두고 무역 창고, 마이크로 창업특구, 마이크로 물류특구 등을 발전시키며 이우의 집화창고, 지역창고, 해외창고 서비스 능력을 강화하여 무역 체인의 각 링크를 연결함으로써 ‘물류창고+’ 서비스 체계를 구축합니다. ',
    thirdDescribe2:
      'Global Yida는 고도의 표준화, 정보화, 가시화 물류 정보 플랫폼을 조성하기 위해 노력하며 이우시의 단편적 물류 수요를 취합하여 이우의 무역 주체, 화물 운송 기업을 지원하며 보다 편리하고 효율적인, 저비용의 통관 물류 서비스를 제공할 것입니다.',
    thirdDescribe:
      'Chinagoods 플랫폼에서는 다양한 물류 서비스 공급업체 중 최상의 액세스를 선정하여 이우시 소상품 시장의 온라인, 오프라인 시장을 위한 단거리 배송, 택배 배송, 해운 운송, 항공 운송 등 방식을 모두 포함하는 국내, 국제적인 양질의 물류 서비스를 제공할 것입니다.',
    marketTitle: '실물 시장',
    marketTitle1: '全球最大的小商品批发市场',
    marketDescribe:
      '义乌中国小商品城创建于1982年，现拥有营业面积640余万平方米，商位7.5万个，从业人员21万多，日客流量21万人次，经营26个大类、210万个单品。被联合国、世界银行与摩根士丹利等权威机构称为“全球最大的小商品批发市场”…',
    detailIntroduction: '详细介绍',
    joinMarket: '시장 입주',
    squareMetre: '平方米',
    shangwei: '个商位',
    dalei: '个大类',
    typeBusiness: '种商品',
    seeDetails: '상세 보기',
    bookHotel: '호텔 예약'
  },
  mapinfo: {
    nationTitle: '해외 진출현황',
    nationTitle2: '국가의 해외시장 진출 전략에 맞춰 국유기업의 선두자 역할 수행 ',
    itinerary: '중국 일대일로 전략',
    operating: '진출 지역',
    preparation: '준비 지역',
    panama: '파나마',
    ethiopia: '에티오피아',
    gibbdike: '지부티',
    burma: '미얀마',
    Korea: '한국',
    Spain: '스페인',
    Germany: '독일',
    Czechia: '체코',
    Rwanda: '르완다',
    UnitedArabEmirates: '아랍에미리트',
    Yiwu: '중국 이우',
    Japan: '일본',
    Operator: '운영주체',
    Office: '사무실',
    Showroom: '전시장',
    cChu: 'CCCL'
  },

  footer: {
    txt1: '국유기업 신용 보장',
    txt2: '신뢰할만한 경영자',
    txt3: '낮은 물류 비용',
    txt4: '편리한 수출입',
    listOne: '파트너 신청',
    listOne1: '시장 경영자',
    listOne2: '생산자',
    listOne3: '전시회 참가자',
    listOne44: '제3자 기관',
    listOne5: '전문인력',
    listTwo: '판매자 센터',
    listTwo1: '판매자 로그인',
    listTwo2: '플랫폼 규칙',
    listTwo3: '市场시장 서비스服务',
    listTwo4: '물류 유통',
    listTwo5: '산업 금융',
    listThree: '쇼핑 가이드',
    listThree1: '무료 회원가입 ',
    listThree2: '구매 프로세스',
    listThree3: '계약 주문',
    listThree4: '지불 방식',
    listThree5: '자주하는 질문',
    listFour: '기업 소개',
    listFour1: '이우 소개',
    listFour2: '시장소개',
    listFour3: '공지사항',
    listFour4: '해외 진출현황',
    listFour5: 'CCC Group',
    txtContent:
      '플랫폼 개발 및 운영자인 저희 그룹은 이우시 최대의 국유기업 상장 그룹이자 이우시 실제 소상품 시장의 관리자입니다.',
    txtContent1:
      'Chinagoods 플랫폼을 통해 온라인에서 상품을 판매하는 매장은 모두 이우시 소상품 시장에 오프라인 점포를 보유하고 있으며 온오프라인 관리를 통해 신뢰할 수 있는 거래를 보장합니다.',
    txtContent2:
      '이우는 중국의 물류 허브이며 2019년 택배 배송량은 광저우에 이어 2위를 차지하였습니다. 이우에서는 낮은 비용으로 세계 각지로의 물류 배송이 가능하며, 이를 통해 전체 거래 비용을 효과적으로 낮출 수 있습니다.',
    txtContent3:
      '이우는 이미 비준을 획득한 종합보세구역이며 특히 수 년 간 수출주도형 경제 발전을 추진하여 천혜의 수출입 정책, 자원과 관련 전문 인력을 보유하게 되었습니다.',
    buyAppDownload: '구매자 App 다운로드',
    hotline: '시장 서비스 핫라인',
    onToFive: '월요일 ~ 금요일',
    zheSafe: '저장성 공안기관 사이트 서비스 플랫폼',
    netWorkTrue: '네트워크 문화 경영허가증',
    zheWwen: '저장성 제트워크 문화',
    zheWwenNum: '(2020)1471-068번',
    radioTv: '라디오 TV 프로그램 제작 경영허가증',
    zheNum: ' (저)자(字) 제05037호',
    marketName: '시장명 등기증',
    indystry: '공상시자',
    indystryNum: '3307821094번',
    officialLink: '공식계정 ',
    attention: '위챗 공식계정 QR코드',
    commodity: '프라이버시권 성명 및 보호정책',
    record: '등록',
    recordZhe: '절ICP비',
    recordNum: '20008226번',
    recordCopy: '©2020',
    company: '이우 중국 소상품타운 빅데이터 유한공사',
    copyRight: '저작권 소유',
    userSerect: '이용자 서비스 약관'
  },
  shop: {
    favorite: '내가 찜한 상품',
    advisory: '온라인 상담',
    videoCall: '영상통화',
    category: '상품 카테고리',
    desc: '점포 소개',
    home: '점포 홈',
    map: '길찾기 ',
    commodity: '점포 상품',
    detailDesc: '자세한 소개',
    recommend: '판매자 추천',
    qualification: '등급',
    buyerRating: '누적 평점',
    evaluation: '평가 하 다.',
    star: '성.',
    ranking: '등.',
    betterThan: '동종업체~보다 우수 ',
    similarBusinesses1: '전체업체~보다 우수',
    similarBusinesses2: '전체업체~보다 우수',
    monthlyTurnoverRanking: '최근 한달 거래 랭킹',
    honor: '자격증 내역',
    shopNavigation: '점포위치',
    viewShop: '점포정보',
    phone: '전화번호',
    date: '영업시간',
    main: '주영업',
    dayRanking: '당일 거래금액 순위(위)',
    dayNumber: '당일 거래 주문수량(건)',
    market: '시장에 총개의 매장',
    typeStar1: '1 성.',
    typeStar2: '2 성.',
    typeStar3: '3 성.',
    typeStar4: '4 성.',
    typeStar5: '5 성.'
  },
  live: {
    live1: 'LIVE',
    live2: 'LIVE',
    replay: '재방송',
    treasurerLive2: 'LIVE중인 방송',
    wonderfulPlayback: '재방송',
    toChatWith: '발표자와 대화?',
    switchLive: '방송보기',
    isLiving: '판매자 방송 LIVE',
    comeandWatch: '시청 참여',
    have: '개의 새로운 ',
    newInfo: '메시지가 있습니다.',
    tryAgain: '다시보기 코드변환 중입니다. 잠시 후 다시 시도해주세요.',
    relateGoods: '에 대한 검색결과가 없습니다.',
    noPower: '현재 초청자 대상 라이브중입니다. 시청 권한이 없습니다.',
    interaction: '메시지를 보내 라이브에 참여'
  },
  member: {
    status: {
      contract: '계약조회',
      pay: '결제'
    },
    order: {
      all: '전체',
      selfCenter: '마이페이지',
      allOrder: '전체주문',
      detail: '주문상세정보',
      wareAddr: '창고주소',
      shipper: '상품수령인',
      title: '내 주문',
      orderDate: '주문시간',
      cacelDate: '취소 일시 ',
      paymentDate: '결제시간',
      returnDate: '반송시간',
      revokeReturn: '환불취소',
      orderInfo: '주문정보 ',
      orderNumber: '주문번호 ',
      business: '구매 업체 ',
      paymentType: '결제방식 ',
      wxpay: 'WeChat Pay',
      cash: '현금 지불',
      alipay: 'Alipay',
      cardpay: '반송시간',
      orderStatus: '카드결제',
      address: '상품 수령지',
      logistics1: '물류',
      logistics2: '물류 방식 ',
      payTheBalance: '잔금결제',
      cancelOrder: '주문취소',
      applyReturn: '환불신청',
      refundCancel: '환불취소',
      refundCheck: '환불 확인 대기',
      returnOut: '반품완료',
      refunding1: '환불작업 중',
      refunding2: '반품중',
      delayedReceipt: '수령연기',
      confirmReceipt: '수령확인',
      toEvaluate: '평가하기',
      postAReview: '평가등록',
      overview: '종합평가',
      myComment: '나의 평가',
      cancelReturns: '반품 취소',
      returnsDetail1: '환불 상황',
      returnsDetail2: '환불 상세정보 ',
      merchantReply: '답변',
      viewLogistics: '물류정보',
      pendingPayment: '결제대기',
      orderCancelled: '주문이 취소됨',
      toBeDelivered: '출하대기',
      to_pay: '결제 대기',
      shipped: '출하완료',
      comment: '평점대기',
      completed: '완료',
      refund: '환불작업 중',
      toCheck: '확인 대기',
      cancel: '취소',
      refundConfirm: '업체 환불 동의',
      refundSuccess: '환불완료',
      refundDown: '환불 닫기',
      warehouse: '자체 출고',
      sendGoods: '직접 배송 ',
      selfTake: '현장 출고',
      logisticNews: '물류정보 무',
      commentTips: '이번 거래에 만족하셨습니까? 의견을 작성해 주세요.',
      returnTips1: '환불신청서가 성공적으로 제출되었습니다. 업체 측의 처리작업을 기다려주세요. ',
      returnTips2: '업체 측이 환불에 동의했습니다. 환불금액 ',
      returnTips3: '업체 측의 상품수령 후, 지불한 결제수단으로 환불됩니다.  ',
      orderSearchTips: '주문번호 혹은 상품명',
      emptyEvaluationTips: '평가 내용을 아직 작성하지 않았습니다.',
      deletePrompt: '주문 취소 후 되돌릴 수 없습니다. 취소하시겠습니까?',
      returnPrompt: '환불취소 후, 해당 상품은 환불이 더 이상 불가합니다.환불을 취소하시겠습니까? ',
      calcelTit: '주문취소?',
      calcelTits: '주문 취소 후 되돌릴 수 없습니다. 취소하시겠습니까?',
      cancelSuc: '주문취소 완료',
      cancelOprate: '조작 취소',
      to_send: '출하대기',
      to_sign: '계약 대기',
      toPayDeposit: '지불해야 할 계약금',
      toPayFinal: '지불해야 할 잔금',
      toReceive: '수령 대기',
      invalid: '무효',
      toStockUp: '주문 이행중',
      evaluateSuc: '홈',
      receptSuc: '수령확인',
      rateTit: '평가등급 선택',
      changeTelephone: '휴대전화 변경',
      payStatus: '지불 상태'
    },
    favorite: {
      title: '내가 찜한 상품',
      shop: '점포',
      commodity: '상품',
      category: '고리',
      allMarkets: '전체시장',
      title2: '저장한 가게',
      market: '시장',
      HY: '篁园',
      BW: '宾王',
      FH: '孵化区',
      viewCode: 'QR코드 스캔'
    },
    address: {
      title: '상품 수령지',
      subTitle: '수령지 관리',
      receiver: '수령인',
      phone: '휴대전화',
      operating: '조작',
      addAddress: '새 수령지 등록',
      changeAddress: '수령지 수정',
      setAsDefault: '기본주소로 설정',
      defaultAddress: '기본 설정',
      name: '수령인',
      citizenship: '국적',
      area: '소재지',
      address1: '주소',
      address2: '상세주소',
      deletePrompt: '주소삭제후복구가 불가합니다. 삭제하시겠습니까?'
    },
    myInfo: {
      title: '개인정보',
      telephone: '휴대전화',
      password: '비밀번호',
      email: 'E-mail',
      unbounded: '미연계',
      changeTelephone: '휴대전화 변경/신규 추가',
      changeEmail: '이메일 변경/신규 추가',
      changePassword: '비밀번호 변경',
      changeDetail: '자료 수정',
      word1: {
        title: '휴대전화 변경',
        code: '인증코드',
        getCode: '인증코드 받기',
        changePassword: '비밀번호 변경',
        newPassword: '신규 비밀번호',
        changeEmail: '이메일 변경',
        email: 'E-mail',
        pleaseCode: '인증코드',
        pleaseEmail: '입력하시오',
        pleaseNewpassword: '입력하시오'
      },
      authentication: '실명인증'
    },
    news: {
      title: '공지사항',
      titleContent: '쪽지내용',
      date: '시간',
      operating: '조작',
      tips: '기독 표기',
      open: '더보기',
      packup: '접기'
    },

    work: {
      title: '내 1:1 질문',
      allWork: '전체 1:1 질문',
      processing: '처리 중',
      processed: '처리완료',
      addWork: '1:1 질문 추가',
      number: '번호',
      workNumber: '1:1 질문 번호',
      problemDescription: '문제점',
      updateDate: '업데이트 시간',
      addDate: '제출시간',
      type1: '유형',
      type2: '질문유형',
      status: '작업상태',
      operating: '조작',
      sendAnnex: '첨부파일',
      recording: '대화기록',
      reply: '답장하기',
      surname: '성',
      name: '이름',
      phone: '휴대전화',
      email: 'E-mail',
      viewWork: '1:1 질문 상세정보',
      sendSuccess: '첨부성공',
      submitSuccess: '1:1 질문 접수 완료',
      uploadTips: '첨부파일 크기는 2M미만, 이미지와 PDF형식 지원(최대 9개)',
      submitSuccessMessage: '관리자가 현재 1:1 질문을 처리하고 있으니 기다려주세요~',
      details: '상세정보',
      viewWorks: '1:1 질문 확인'
    },
    returns: {
      returnDetail: '환불 상세정보 ',
      returnsTips1: '반송제품을 선택하고 수량을 확인하세요',
      returnsTips2: '환불정보를 작성해 주세요.',
      reason: '환불이유',
      reasonMessage: '환불 이유를 선택하세요.',
      description: '문제점',
      descriptionMessage: '환불의 구체적인 이유를 설명해 주세요',
      number: '신청개수',
      amount: '환불금액',
      return: '환불신청',
      cancel: '환불취소',
      returnDate: '환불시간',
      uploadTips: '원활한 문제해결을 위해 사진을 꼭 첨부하세요.(최대 9장, 1장당 5M미만)',
      orderNote: '주문비고',
      leaveMessage: '판매자에게 메모 남기기'
    },
    account: {
      title: '외환계좌 ',
      addAccount: '외환계좌 추가',
      accountManage: '외환 계좌 관리',
      changeAccount: '외환계좌 수정',
      person: '지급인 ',
      accountNumber: '결제계좌',
      setAccountNumber: '기본계좌 ',
      payAccountNumber: '결제계좌 '
    }
  },
  commodity: {
    commodityInfo: '제품정보',
    attributes: '속성',
    unitPrice: '단가',
    quantity: '수량',
    subtotal: '소계',
    weight: '무게',
    operating: '조작',
    title: '주문 정보를 확인하세요.'
  },
  cart: {
    addCart1: '장바구니 담기',
    addCart2: '주문정보 작성 및 제출',
    addCart3: '주문 결제',
    addCart4: '결제 결과',
    settlement: '결제',
    sign_pay: '계약/결제',
    totalPrice: '합계',
    discount: '할인',
    clearCart: '장바구니 비우기',
    deleteCommodity: '선택상품 삭제',
    inStock: '재고 있음',
    soldOut: '재고 부족',
    selectAddress: '선택하세요상품 수령지',
    selectShippingMethods: '물류 방식 선택',
    confirmOrder: '주문 정보를 확인하세요.',
    freight: '운임포함',
    taxrate: '관세',
    theAmountOfGoods: '상품금액',
    merchantOffers: '업체할인',
    grossWeight: '총무게',
    totalPayable: '총 결제금액',
    backToCart: '장바구니로',
    toCart: '장바구니로',
    submitOrders: '주문서 제출',
    recentlyJoined: '최신제품',
    shoppingCartTotal: '장바구니 상품 총',
    pieces: '개',
    backToHome: '홈으로',
    checkOrder: '주문확인',
    paySuccess: '결제성공',
    repay: '다시시도',
    paySuccessMessage: '결제된 금액',
    payError: '결제실패',
    payErrorMessage: '결제에 문제가 생겼습니다. 다시 시도해 주세요.',
    showAddress: '더보기',
    hideAddress: '접기',
    payTheBalance: '잔금결제',
    toSignUp: '계약해 주세요',
    toPayDeposit: '보증금 지불',
    deleteOrder: '주문 삭제',
    toPay: '겔제하기',
    addCart5: '계약확인',
    title: '계약합의조항 내역',
    pdf: '주문계약.pdf',
    linkType:
      '링크를 클릭하여 체결하신 계약을 확인할 수 있으며, 주문센터에서도 확인 가능합니다. 확인 뒤 보증금 지불을 잊지 마세요~',
    canClick: '클릭',
    paySuccess1: '계약금 지불 성공',
    payTips: '지불이 지연되었습니다. 구체적인 내용은 주문센터 페이지에서 확인해주세요.',
    fare: '배송비',
    orderPrice: '주문환불금액'
  },
  customer: {
    feedback: '문제 피드백',
    phone: '고객센터전화',
    email: '서비스 메일'
  },
  publicText: {
    location: '현재 위치',
    noData: '잠시 무 데이터',
    searchTips: '제품검색 키워드',
    searchTipsTwo: '가게 명칭/휴대전화',
    clickUpload: '클릭하여 첨부',
    chosen: '선택',
    list: '목록',
    map: '지도 보기',
    sales: '누적 판매량',
    price: '가격 순',
    favorite: '찜하기',
    toBeCollected: '찜하기',
    collected: '찜한상품',
    commodity: '상품',
    shop: '가게 명칭',
    watch: '시청자 수',
    hello: '안녕하세요, ~님',
    welcome: '환영합니다!',
    user: '~님',
    clickwhatIsProcurement: '옴니 시나리오 쇼핑이란？',
    whatIsProcurement: '옴니 시나리오 쇼핑（Omni-scenario Purchasing)',
    procurement:
      '상품 구매 과정에서 다양한 거래 시나리오가 실현될 수 있습니다. 예를 들어 오프라인 매장에서 상품을 선택하고 직접 카드로 결제할 수 있고, 오프라인 광고의 QR코드를 통해 거래할 수도 있으며, 기존 고객의 경우 은행 계좌이체를 통해 대규모 거래를 진행할 수 있습니다. 뿐만 아니라 온라인 전자상거래 매장에서 온라인, 오프라인 거래를 진행할 수 있고, Wechat 대화창을 통해 상품 링크를 발송하여 거래하거나 라이브 방송을 통해 직접 거래를 진행할 수도 있습니다.',
    QA: '쇼핑 Q&A',
    grabbed: '판매',
    endOfDistance: '남은시간',
    pieces: '~개',
    productDetails: '상세정보',
    ranking: '랭킹',
    storeRanking: '관련점포랭킹',
    productsRecommended: '연관추천상품',
    recommendedForYou: '추천상품',
    sorry: '죄송합니다，없습니다',
    relatedProducts: '검색결과가',
    allMarkets: '전체시장',
    explosion: '인기상품 추천',
    found: '검색된',
    relatedShops: '관련',
    home: ' 점포곳',
    mapMode: '지도 보기',
    listMode: '리스트 보기',
    uploadAttachment: '파일첨부',
    rate: '평점 순',
    post: '등록',
    vipPrice: '회원가',
    desc: '설명 텍스트',
    sameProducts: '유사 상품 ',
    tips:
      '계약 거래 및 오프라인 송금은 개별 점포 거래 시에만 지원됩니다.계약 거래 시 개인/기업  실명 인증이 필요합니다. ',
    noGoods: '상품이 없습니다. ',
    day: '일간',
    hour: '시간',
    minute: '분',
    second: '초',
    hotGoods: '인기상품 추천'
  },
  btn: {
    search: '검색',
    searchAll: '전체 검색',
    searchShop: '점포 내 검색',
    more: '자세히',
    addCart: '장바구니 담기',
    buy: '바로구매',
    moreOptions: '기타 옵션',
    putAway: '접기',
    determine: '확인',
    cancel: '취소',
    multipleChoice: '선택',
    send: '첨부하기',
    delete: '삭제',
    selectAll: '전체선택',
    modify: '수정',
    submit: '제출',
    company: '저장중국 소상품타운그룹 유한주식회사',
    title: '외국인 구입자의 이우구매행위에 대한 보상방법',
    explains:
      '请发起申请企业及时告知所邀外商，此次享受补贴的必要条件如下：必须要有5万美元以上的交易凭证（采购合同+汇款凭证），必须是非人民币的外汇收款，收款方一定要是注册在义乌的企业。',
    tips:
      '若您通过补贴条件审核，且您所在的国家/地区有航班直达义乌，我们将提供目的地为义乌的单程机票补贴（经济舱）；若您所在的国家/地区无航班直达义乌，我们将提供最终目的地为义乌的不超过一次转机的单程联程机票补贴（经济舱）。',
    month: '2020年2月19日',
    illustration: '설명',
    Directflight: '单程',
    oneTransit: '一次转机',
    Transit: '转机',
    Application: '이우시 방문 외국 기업인',
    word: '숙박 지원 신청서 ',
    noFree: '说明：3月10日之后来到义乌的友商，不享受免费食宿 。酒店由商城集团指定。'
  },
  application: {
    slgon: '外商/华侨来义采购行宿补贴申请表',
    yourName: '2.姓名',
    placeholderSurname: '请输入姓',
    placeholderName: '请输入名',
    yourSex: '3.性别',
    male: '男',
    female: '女',
    sexRule: '请选择性别',
    nameRule: '请输入名',
    surnameRule: '请输入姓',
    yourBirthday: '4.出生日期',
    birthdayRule: '请选择出生日期',
    birthdayArrivalDate: '请选择预计抵达日期',
    passportCountry: '5.护照颁发国家/地区',
    pleaseChoose: '请选择',
    passportNumber: '6.护照号码',
    passportCountryRule: '请输入护照颁发国家/地区',
    pleaseInput: '请输入',
    contactWays: '7.联系方式',
    domesticTel: '中国手机',
    overseasTel: '国外手机',
    overseasTelInput: '在中国境外可联系到申请人的手机号',
    domesticTelInput: '在中国境内可联系到申请人的手机号',
    email: '电子邮箱',
    placeholderTel: '自己或是中国境内联系人手机号码',
    domesticTelCue: '提示：可以填自己或是中国境内联系人手机号码',
    flightInfo: '8.拟定航班信息',
    airlineCompany: '航空公司',
    flightNumber: '航班号码',
    departureDate: '起飞日期',
    arrivalDate: '9.预计抵达义乌日期',
    time: '选择日期',
    explain: '说明：',
    type2list1: '补贴来义航班经济舱费用50%',
    type2list2: '三日酒店免费食宿，酒店由商城集团指定',
    type2list3: '离义航班费用不纳入补贴范围。',
    type3:
      '2月29日前抵义15日内在义采购金额在5万美元以上，航班经济舱费用全额补贴；3月1日至10日间抵义，15日内在义采购金额在5万美元以上，航班经济舱费用补贴50%。离义航班费用不纳入补贴范围。',
    address: '10.在义乌住址',
    city: '市',
    street: '街镇',
    detailAddress: '详细地址：',
    freeAccommodation: '需安排免费住宿',
    homeAddress: '自有居所',
    hotelTime: '酒店住宿日期：',
    startTime: '入住日期',
    endTime: '离店日期',
    adslist1: '2月29日前抵义，最长享受7天免费食宿；',
    adslist2: '3月1日至10日间抵义，最长享受3天免费食宿。',
    adslist3: '酒店由商城集团指定。',
    adslist4: '说明：3月10日前抵义的，提供三日免费食宿，酒店由商城集团指定。',
    cashExplain: '补贴兑现说明：',
    explainTxt:
      '1.外商并经义乌外贸企业事前备案的，在义期间同义乌商贸企业或市场经营户采购金额在五万美元以上并审核有效的，携带采购合同及汇款凭证，前往义乌小商品城采购商服务中心（义乌市国际商贸城四区1楼南2号门）兑现补贴。本办法由商城集团负责解释。',
    purchaserType: '1.采购商类型',
    purchaserType1: '第一类：在义乌注册的商贸型企业外籍股东或外籍法定代表人',
    purchaserType2: '第二类：在义乌有出入记录且有采购记录的外籍采购商',
    purchaserType3: '第三类：在义乌无出入记录或无采购记录的外籍采购商',
    purchaserType4:
      '第四类：有国外长居或永居身份、在境外注册有商贸企业的股东或法人代表、且有义乌出入境记录的中国籍采购商',
    accessRecords: '出入记录：',
    purchaseRecord: '采购记录：',
    cue1: '提示：请提供相关文件证明，支持图片和pdf文件。',
    cue2: '出入记录：2020年1月1日之前的义乌出入境记录、义商友卡、义乌酒店入住记录任一种。',
    cue3: '采购记录：2020年1月1日之前的同义乌商贸企业或市场经营户的资金往来凭证。',
    enclosure: '附件：',
    enclosure1: '居留许可文件：',
    enclosure2: '经营许可文件：',
    cue4: '提示：请提供义乌商贸企业营业执照照片或扫描件，支持图片和pdf文件。',
    cue5:
      '提示：请提供请提供义乌外贸企业或市场经营户基础信息（加盖公章的营业执照或工商证明照片或扫描件） ，支持图片和pdf文件。',
    cue6: '提示：',
    cue7: '(1) 由境外国家外国人管理局或类似职能部门下发的居留许可文件的扫描件。',
    cue8: '(2) 由境外国家商管部门下发的商贸型企业经营执照等文件，或股东证名。',
    cue9: '(3) 2020年1月之前在义乌的出入境记录、来义交通凭证或义乌酒店入住记录。',
    cue0:
      '(4) 2020年1月之前，以本人或注册公司为主体，在义乌生成的采购金额不小于5万美金的订单或资金往来凭证。',
    agree: '我已知晓并接受',
    agreement: '《关于外籍采购商来义采购的奖励办法》',
    companyContant: ' 11.义乌境内发起邀请单位联系方式',
    companyName: '单位名称',
    companyPerson: '联系人',
    companyTel: '手机号码',
    sendEmailCue: '如不方便网页提交，可发申请邮件到 ',
    emailAds: 'freetoyiwu@chinagoods.com',
    passportNumberRule: '请输入护照号码',
    emptyRule: '内容不能为空',
    endtimeRule: '请选择结束时间',
    submit: '提交',
    company: '浙江中国小商品城集团股份有限公司',
    title: '关于外籍采购商来义采购的奖励办法',
    explains:
      '请发起申请企业及时告知所邀外商，此次享受补贴的必要条件如下：必须要有5万美元以上的交易凭证（采购合同+汇款凭证），必须是非人民币的外汇收款，收款方一定要是注册在义乌的企业。',
    tips:
      '若您通过补贴条件审核，且您所在的国家/地区有航班直达义乌，我们将提供目的地为义乌的单程机票补贴（经济舱）；若您所在的国家/地区无航班直达义乌，我们将提供最终目的地为义乌的不超过一次转机的单程联程机票补贴（经济舱）。',
    month: '2020年2月19日',
    illustration: '说明',
    Directflight: '单程',
    oneTransit: '一次转机',
    Transit: '转机',
    Application: '外商来义采购',
    word: '行宿补贴申请表',
    noFree: '说明：3月10日之后来到义乌的友商，不享受免费食宿 。酒店由商城集团指定。'
  },
  welecomeToYiWu: {
    toDeclare: '신고하기',
    toApply: '신청하기',
    toHotel: '去预定',
    hotel: '酒店预订',
    currentPosition: '현재 위치',
    convention: '전시회 참가기업 신고 ',
    name: '이름',
    Gender: '성별',
    man: '남',
    women: '여',
    idType: '신분증종류',
    idNumber: '신분증번호',
    Nationality: '국적',
    Province: '성소재지',
    city: '도시',
    companyAddress: '회사주소',
    companyName: '회사명',
    jobTitle: '직위',
    Department: '부서',
    Contacts: '연락가능수단',
    email: 'E-mail',
    interest: '흥미가 있으신 유형은?(복수선택 가능)',
    companyBusiness: '회사의 업무성질(복수선택 가능)',
    others: '기타(차례로 적어주세요)',
    attend: '전시회 참석목적(복수선택 가능)',
    wayConcatType:
      '집행위원회에서 어떤 방식으로 귀하께 전시회 참석신청을 드릴것을 원하십니까?(단일선택)',
    submit: '제출',
    purchaser: '구매기업 건강상태 신고 ',
    declareChoose: '신고선택',
    placeLocation: '호적소재지',
    foreignCard: '상우카드 유무',
    yes: '유',
    no: '무',
    currentYiWuAddress: '이우거주지',
    currentHealthy: '본인 현재 신체상황',
    Fever: '발열',
    Cough: '기침',
    Ingoodhealth: '건강',
    daysOut: '14일전부터 지금까지 본인의 외출상황',
    type1: '1、후베이성,온주,타이저우에서 왔거나 간적이 있다',
    type2: '2、확진자 혹은 밀접접촉자와 접촉을 한적이 있다',
    type3: '3、유행성 전염병 병력이 있거나 증상이 있다',
    familyMembers: '본인 혹은 가족중에 확진자와 접촉한 적이 있다',
    commitmentChecked:
      '본인은 상기상황이 사실임을 약속하고 만약에 잘못된 부분이 있으면 해당하는 법적책임을 질것입니다.',
    entry: '외국인 입국 신청서 ',
    type: '유형',
    phone: '전화번호',
    chineseName: '중국어이름',
    dateOfBirth: '출생년월일',
    placeOfBirth: '출생지',
    passportType: '여권유형',
    passportNumber: '여권번호',
    IssueDate: '발급날짜',
    validityOfPassport: '발급유효기간',
    entryTime: '입국시간',
    validityOfVisa: '비자유효기간',
    visaNumber: '비자번호',
    visaType: '비자종류',
    word1: {
      pleaseEnter: '입력하시오',
      placeSelect: '선택하세요',
      pleaseName: '이름 입력하시오',
      pleaseSex: '성별 선택하세요',
      pleaseIdType: '신분증종류 선택하세요',
      pleaseIdNumber: '신분증번호 입력하시오',
      pleaseLegalIdNumber: '신분증 번호 입력하시오',
      pleaseCountry: '국적 선택하세요',
      pleaseArea: '소재지 선택하세요',
      pleaseDetailAddress: '상세주소 입력하시오',
      pleaseCompanyName: '회사명 입력하시오',
      pleaseDepartment: '부문 입력하시오',
      pleasePosition: '직위 입력하시오',
      pleaseContant: '연락가능수단 입력하시오',
      pleaseLegal: '휴대전화 입력하시오',
      pleaseEmail: '정확한 메일을 입력하시오',
      pleaseInterested: '흥미가 있으신 유형은 선택하세요',
      pleaseBussiness: '회사의 업무성질 선택하세요',
      pleaseAttendPurpose: '전시회 참석목적 선택하세요',
      pleaseWitchConcatType:
        '집행위원회에서 어떤 방식으로 귀하께 전시회 참석신청을 드릴것을 원하십니까 선택하세요',
      pleaseWitchConcatNumber:
        '집행위원회에서 어떤 방식으로 귀하께 전시회 참석신청을 드릴것을 원하십니까 입력하시오',
      placeType: '유형 선택하세요',
      placeChineseName: '중국어이름 입력하시오',
      dateOfBirth: '선택하세 요출생년월일',
      placeOfBirth: '출생지 입력하시오',
      placePassportType: '여권유형 선택하세요',
      placePassportNumber: '여권번호 입력하시오',
      placeIssueDate: '선택하세요 발급날짜',
      placeValidityOfPassport: '선택하세요 발급유효기간 ',
      placeEntryTime: '선택하세요 입국시간 ',
      placeValidityOfVisa: '선택하세요 비자유효기간 ',
      placeVisaNumber: '비자번호 입력하시오',
      placeVisaType: '비자종류 입력하시오',
      placeDeclare: '신고선택 선택하세요',
      placeDomicileLocation: '호적소재지 입력하시오',
      placeFriendsBusinessCard: '선택하세요 상우카드 유무',
      placeCurrentAddress: '이우거주지 입력하시오',
      placeCurrentHealth: '선택하세요 본인 현재 신체상황',
      placeDaysOut: '선택하세요 14일전부터 지금까지 본인의 외출상황',
      placeFamilyMembers: '선택하세요본인 혹은 가족중에 확진자와 접촉한 적이 있다 '
    },
    declareType1: 'COVID-19 대규모 발생지역 외 국내 구매자(Class A)',
    declareType2:
      '후베이성, 타이저우시, 원저우 시 등 COVID-19 대규모 발생 지역의 국내 구매자(Class B)',
    declareType3: '이우시 거주 국외 구매자(Class C)',
    declareType4: '이우시 비거주 국외 구매자(Class D)',
    idcardType1: '신분증',
    idcardType2: '여권',
    idcardType3: '마카오 주민 내지통행증',
    idcardType4: '타이완 주민 내지통행증',
    idcardType5: '홍콩 주민 내지통행증',
    concatType1: 'E-mail',
    concatType2: '위챗',
    concatType3: '전화번호',
    concatType4: '큐큐',
    visaType1: '비자 관련',
    visaType2: '외국인 중국취업허가증',
    visaType3: '이우시에 회사 신규 설립',
    passportType1: '외교',
    passportType2: '공무/공무원',
    passportType3: '일반',
    passportType4: '기타'
  },
  logisticsSide: {
    title: '선적 플랫폼에 적용',
    logan: '등록 후 플랫폼 위탁 신청',
    sender: '발송',
    senderInfo: '보내는 사람 정보',
    recipient: '수령',
    recipientInfo: '받는 사람 정보',
    name: '이름',
    placeholder: '입력하시오',
    placeholderSelect: '선택하세요',
    company: '회사이름',
    telephone: '휴대전화',
    fixedTelephone: '유선전화',
    country: '국적',
    area: '소재지',
    detailAddress: '상세주소',
    checkedItems: '탁송물품',
    checkedName: '탁송물품명',
    cloume: '길이x너비x높이(cm)',
    weight: '무게(kg)',
    delete: '삭제',
    addChecked: '탁송물품 추가',
    othersInfo: '기타정보',
    startTime: '희망출하일',
    endTime: '희망 수령일',
    desc: '탁송물품 설명',
    success: '제출',
    info: '관리자가 현재처리하고 있으니 기다려주세요. ',
    newWord: '새 신청서',
    submit: '탁송 신청서 제출',
    pleaseName: '입력하시오 이름',
    pleaseTelephone: '입력하시오 휴대전화',
    pleaseLegal: '입력하시오 휴대전화',
    pleaseCountry: '선택하세요 국적',
    pleaseArea: '선택하세요 소재지',
    pleaseDetailAddress: '입력하시오 상세주소',
    pleaseCheckedItemName: '입력하시오 탁송물품명',
    pleaseVolume: '입력하시오 탁송물품명 길이너비높이',
    pleaseWeight: '입력하시오 탁송물품명 무게',
    drag: '문서를 여기로 드래그 하세요. 또는',
    expressName: '물류명',
    expressNo: '운송장 번호를'
  },
  newFeedback: {
    location: '현재 위치',
    newWord: '1:1 질문 추가',
    firstname: '성',
    surname: '이름',
    telphone: '휴대전화',
    email: 'E-mail',
    type: '1:1 질문유형',
    desc: '문제점',
    dialogImageUrl: '파일첨부',
    submit: '제출',
    uploadTips: '첨부파일 크기는 2M미만, 이미지와 PDF형식 지원(최대 9개)',
    pleaseTelephone: '휴대전화 입력하시오',
    pleaseType: '유형 선택하세요',
    pleaseDesc: '문제점 입력하시오'
  },
  articleList: {
    title: '목록',
    releasetime: '공개 일시'
  },
  antiepidemic: {
    purchaserRegister: '구매업체 등록 컨설팅',
    provideRegister: '공급업체 등록 컨설팅',
    viewMore: '더 많은 정보 보기',
    location: '현재 위치',
    epidemicZone: '방역 특별구역',
    firstname: '성',
    surename: '이름',
    telephone: '휴대전화',
    country: '국적',
    idcardPic: '신분증 사진',
    idcardPositive: '신분증 앞면',
    idcardOtherSide: '신분증 뒷면',
    uploadTips:
      '*사진은 JPG, PNG, BMP 등 형식을 지원하며 사진 한 장의 크기는 20M를 넘을 수 없습니다!',
    desc: '컨설팅 소개',
    submit: '제출',
    pleaseName: '입력하시오',
    placeTelephone: '입력하시오 전화번호',
    placeCountry: '선택하세요 국적',
    placeIdcardPic: '주민등록증 앞뒤면 업로드',
    placeDesc: '입력하시오 컨설팅 소개',
    placeSelect: '선택하세요'
  },
  account: {
    myInfotitle: '개인정보',
    modify: '수정',
    username: 'ID 로그인 ',
    lagonName: '닉네임',
    country: '국적',
    intetion: '관심상품',
    contractStatus: '계약 등록 여부',
    certified: '인증 완료',
    notCertified: '미인증',
    notSetting: '미설정',
    notRegister: '미가입',
    applyRegister: '가입 신청',
    failRegister: '가입 실패',
    contactManager: '1:1 질문을 관리자에게 제출해 주세요.',
    registered: '가입 완료',
    isTImed: '만기',
    overTime: '기간 만료',
    againRegister: '재가입',
    add: '신규 추가',
    tips: '새로운 계약 거래 방식을 체험하시고 싶다면, 실명인증을 하세요.',
    paySurename: '지급인성',
    payFirstname: '지급인이름',
    payAccountNumber: '지급인계정',
    payCountry: '지급인국적',
    receiveGoods: '수화인 이메일',
    title: '계정로그인',
    placeholderUser: 'ID 로그인',
    placeholderPassword: '비밀번호',
    noLogin: '7일간 무료로그인',
    submit: '로그인',
    goRegister: '인증코드 받기'
  },
  sideMenu: {
    learnMore: '더 많은 활동정보 보기',
    code: '위챗 공식계정 QR코드 '
  },
  submitOrder: {
    contractType: '거래 방식',
    noContract: '비계약 거래',
    Contract: '계약 거래',
    outsideContract: '외환거래',
    linkType:
      '계약 거래 선택 시, 실명 인증 여부를 확인해주세요. 다음 링크를 클릭하여 개인 실명 인증 / 기업 실명 인증을 진행할 수 있습니다. ',
    personCer: '개인 실명 인증',
    companyCer: '기업 실명 인증',
    payAccount: '결제 계좌 선택',
    addAccount: '결제계좌 추가',
    selectAddress: '상품 수령지 선택하세요',
    addAddress: '새 수령지 등록',
    selectLogistics: '물류 방식 선택',
    businessExpress: '직접 배송',
    mallExpress: '쇼핑몰 위탁 배송',
    tips:
      '쇼핑몰 위탁 배송 시, 플랫폼 관리자께서는 물류회사 담당자 및 연락처 정보를 제공해주시기 바랍니다. ',
    accountList: {
      addaAddress: '새 수령지 등록',
      addAccount: '외환계좌 추가',
      name: '연락처',
      placeholderName: '입력하시오 연락처이름',
      placeholdTelephone: '입력하시오 전화번호',
      addAddress: '새 주소',
      placeRecipientName: '수령인이름',
      changeAddress: '변경 주소'
    },
    note: '주의'
  },
  message: {
    sure: '확인',
    cancle: '취소',
    tips: '주의',
    tips1: '비디오 오류, 오류 원인：',
    tips2: '이 제품을 삭제하시겠습니까?',
    tips3: '삭제성공!',
    tips4: '취소삭제',
    tips5: '추가 성공~',
    tips6: '업로드 파일은JPG、JPEG、PNG혹은BPM유형이여야 합니다!',
    tips7: '크기는 2M미만!',
    tips8: '주민등록증 앞뒤면 업로드',
    tips9: '어떠한 제품도 선택하지 않았습니다',
    tips10: '이 조작은 쇼핑 카트를 비우게 됩니다. 계속하시겠습니까?',
    tips11: '여러 가게의 결산을 동시에 할수 없습니다. 다시 선택하세요！',
    tips12: '저장 취소',
    tips13: '저장 완료',
    tips14: '현재 사적 라이브입니다. 잠시 오픈할수 없습니다',
    tips15: '현재 사적 라이브입니다. 계정에 등록후 재시도하십시오',
    tips16: '삭제 후 회복할 수 없습니다. 삭제하시겠습니까?',
    tips17: '기본주소로 설정 성공',
    tips18: '추가 성공',
    tips19: '수정되었습니다',
    tips20: '설정 성공',
    tips21: '업로드 파일은  JPG、JPEG、PNG、GIF 혹은 PDF유형이여야 합니다!',
    tips22: '크기는 5M미만!',
    tips23: '이 메시지를 삭제하시겠습니까?',
    tips24: '면，실명인증을 하세요.',
    tips25: '가입성공',
    tips26: '첨부성공',
    tips27: '인증번호가 이미 발송되었습니다',
    tips28: '주문 삭제?',
    tips29: '주문 삭제성공',
    tips30: '이 기능은 잠시 오픈되지 않았습니다',
    tips31: '처리되면 답장하지 않습니다',
    tips32: '크기는 5M미만!',
    tips33: '해당 점포는 고객 서비스를 오픈하지 않았습니다. 잠시만 기다려 주세요.',
    tips34: '시청 권한이 없습니다.',
    tips35: '이미 대화방 멤버입니다. 중복 가입하지 마십시오.',
    tips36: '대화방에 참여하였습니다.',
    tips37: '신청 성공, 그룹 관리자 확인 대기 중.',
    tips38: '이 조작은 본 계정을 삭제하게 됩니다. 계속하실건가요?',
    tips39: '배송지 주소를 추가해 주세요.',
    tips40: '예',
    tips41: '아니오否',
    tips42: '결제가 완료되었습니까?',
    tips43: '해당 주소를 삭제합니다. 계속하시겠습니까?',
    tips44: '업자가 고객을 위한 계약서를 작성 중이니 기다려 주시길 바랍니다.',
    tips45: '네 알겠습니다',
    tips46: '삭제 후 회복할 수 없습니다. 삭제하시겠습니까?',
    tips47: '새창 만들기 성공',
    tips48: '환불취소 후, 해당 상품은 환불이 더 이상 불가합니다.환불을 취소하시겠습니까? ',
    tips49: '빈메시지는 발송할 수 없습니다.',
    tips50: '나가기 확인',
    tips51: '읽지않은 메시지가 없습니다.',
    tips52: '모두 보기',
    tips53: '성공',
    tips54: '이 사용자를 찾지 못했습니다',
    tips55: '최대 9장사진',
    tips56: '삭제실패',
    tips58: '库存不足'
  },
  foreign: {
    title: '외완주문 내역',
    businessSure: '상점 확인 대기',
    orderNo: '주문번호 ',
    price: '결제금액',
    payMethods: '결제방식',
    type1: '1기',
    type2: '2기',
    type3: '3기',
    confirmInfo: '정보 확인',
    rmbTotal: '위안화 총액',
    proposeTotal: '결제화폐 총액'
  },
  identifier: {
    tips: '주문을 제출했으며 빨리 결제를 완료해 주시길 바랍니다.',
    readInfo: '다음 정보를 자세히 읽어주시길 바랍니다.',
    type1:
      '1. 해당 주문에서 약속한 지불방식은 중국 공상은행이 관리 감독하여 지불하는 것임에 유의하십시오.',
    type2:
      '2. 결제 시  해당 결제금액의 지불번호를 모메에 표기하십시오. 그렇지 않을 경우, 중국 공상 은행이 결제한 돈을 감독 관리할 수 없습니다.',
    type3:
      '3. 다른 결제 방식을 사용하지 마십시오. 그렇지 않을 경우, 중국 공상 은행이 결제한 돈을 감독 관리할 수 없습니다.',
    type4: '4. 결제 순서대로 메모에 정확한 지불번호를 입력하십시오.',
    type5: '5. 개인의 실수로 인한 손실이라면, 중국 공상은행은 어떠한 책임도 지지 않습니다. ',
    collectAccountInfo: '수취계좌 내역:',
    payCodeInfo: '결제코드 정보 ',
    tips1:
      '주의: 결제 시  해당 결제금액의 지불번호를 모메에 표기하십시오. 그렇지 않을 경우, 중국 공상 은행이 결제한 돈을 감독 관리할 수 없습니다.',
    number: '수취계좌',
    payCode: '결제코드',
    pay: '결제금액',
    bank: '수납은행',
    payee: '수취인',
    payeeAccount: '수취계좌번호',
    payeeAddress: '수취인 주소',
    contant: '연락처',
    telephone: '연락가능수단'
  },
  chat: {
    cancelBlackout: '수신거부 취소',
    tips1: '블랙 명단이 비여있습니다',
    noNickname: '이 사용자는 닉네임을 설정하지 않았습니다',
    joinBlackList: '이 사용자를 블랙 명단에 넣기',
    joinBlack: '블랙 명단에 가입',
    removeBlackList: '이 사용자를 블랙 명단에서 이동',
    removeBlack: '블랙 명단에서 이동',
    deleteSession: '대화 삭제',
    systemInfo: '시스템 공지사항',
    mentioned: '[누군가가 나를 지목했다]',
    refreshList: '리스트 갱신',
    startSession: '대화 시도',
    pleaseUserId: 'ID로그인입력하시오',
    viewDetail: '상세한 정보 보기',
    noMore: '더이상 힌트가 없습니다',
    backLatest: '최신 위치로 돌아가기',
    editProfile: '개인자료 편집',
    headPortrait: '프로필 사진',
    nickname: '닉 네임',
    pleaseHeadPro: '头像地址(URL)',
    noDisplay: '디스플레이가 안됩니다',
    tips2: '头像应该是 Url 地址',
    sessionList: '대화 리스트',
    balckList: '블랙 명단 리스트',
    close: '닫기',
    rateAndProposal: 'IM DEMO에 대한 평가와 건의',
    custom: '자아설정 메시지를 분석할수 있습니다 ',
    clickDownload: '클릭하여 다운',
    clickDetail: '클릭하여 상세한 내용보기',
    handle: '처리',
    handleGroupApp: '단체방 가입 신청 처리',
    processResult: '처리 결과: ',
    agree: '동의',
    refuse: '거절',
    postscript: '추가 메시지: ',
    pleasePostscrpt: '추가 메시지 입력하시오',
    clickPlay: '클릭하여 재생',
    onPhone: '전화 왔어요',
    onPhoning: '전화 거는 중',
    noCamera: '캠을 열지 않았습니다',
    cameraPower: '캠과 마이크를 연결후 방문권한이 있습니다',
    withdraw: '철회',
    reEdit: '재편집',
    notSupportMessageType: '지지하지 않는 메시지유형: ',
    expression: '표정 발송',
    sendCustomMessage: '자아설정 메시지를 발송',
    rateAndUse: 'IM Web demo에 대한 건의와 사용소감',
    suggest: '건의',
    tips3: 'Enter를 클릭하여 메시지 발송, Ctrl+Enter는 라인 피드',
    notSupportMessage: '지지하지 않는 메시지',
    welcome: '환영합니다: ',
    joinChat: '채팅방에 가입',
    groupMembers: '단체방 성원: ',
    exitChat: '채팅방에서 퇴출',
    kickoutGroup: '단체방에서 강퇴',
    cover: '는',
    becomeAdmain: '관리자가 되다',
    revokedAdmain: '철회된 관리자',
    changeGroupDetail: '단체방 자료 수정',
    changeMemberDetail: '단체방 멤버자료 수정',
    groupMessage: '[단체방 소식 제시]',
    groupSystemMessage: '단체방 시스템 통지',
    systemMessage: '시스템 통지',
    preview: '속성',
    conversation: '대화'
  },
  private: {
    privateGoods: '私密商品',
    enterProPas: '输入商品密码',
    passwordError: '密码错误',
    price: '价格',
    startBatch: '起批量',
    viewPrivateGoods: '查看私密商品'
  },
  zhenmodify: {
    door: '门到门',
    port: '港到港',
    price: '价格',
    ratings: '综合评分',
    sellerrating: '店铺等级',
    currentpoint: '当前积分',
    livevideo: '直播视频',
    ALLMarkets: '全部市场',
    Collection: '收藏',
    Navigation: '进入导航',
    Bulletin: '商铺公告',
    Replay: '查看回放',
    LiveIntroduction: '简介',
    Nointroduction: '暂无简介',
    Views: '观看',
    Products: '直播宝贝',
    LiveReplay: '直播回放',
    startquantity: '起批量',
    Quantity: '数量',
    Cart: '加入进货单',
    Buy: '立即购买',
    Liveing: '正在直播',
    View: '查看直播',
    Noscore: '暂无评分',
    Viewers: '观看',
    points: '分'
  }
}
